/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import { CatalogueYupSchema } from 'src/containers/catalogue-container/CataloguePropTypes';
import { useHistory } from 'react-router-dom';
import RoutingUtil from 'src/utils/RoutingUtil';
import { isProduction } from 'src/config/index';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { includeStamp } from 'src/utils/StampUtils';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import ProductDropDown from 'src/business-components/ProductDropDown';
// import CommissionDropDown from 'src/business-components/CommissionDropDown';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import { catalogueResetAction, catalogueUpsertAction } from './actions/CatalogueActions';
import {
    PRODUCT_CATEGORY_TYPES_LIST,
} from '../product-container/ProductConstants';
import CatalogueMetaFactory from './factory/CatalogueMetaFactory';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Catalogue Details</h5>
                <Form autoComplete="disabled">
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Company</label>
                            <CompanyDropDown
                                value={values.companyId}
                                name="companyId"
                                disabled={Boolean(values._id)}
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Category</label>
                            <FormikSelect
                                items={PRODUCT_CATEGORY_TYPES_LIST}
                                name="productCategory"
                                className="form-control"
                                disabled={Boolean(values._id)}
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label>Product</label>
                            <ProductDropDown
                                name="productId"
                                value={values.productId}
                                productCategory={values.productCategory}
                                disabled={Boolean(values._id)}
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Catalogue Name</label>
                            <FormikInput
                                name="catalogueName"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        {/* <div className="form-group col-md-3">
                            <label>Company Commission Slab</label>
                            <CommissionDropDown
                                value={values.companyCommissionId}
                                name="companyCommissionId"
                            />
                        </div> */}
                    </div>

                    <CatalogueMetaFactory
                        category={values.productCategory}
                    />

                    <div className="text-center py-4 mt-3">
                        <FormikCreateSearchClear
                            isSubmitting={isSubmitting}
                            isUpdate={Boolean(values._id)}
                            onSearch={onSearch}
                            onClear={onClear}
                            resetForm={resetForm}
                            values={values}
                            submitScope="master.catalogue_manager.manage.submit"
                            searchScope="master.catalogue_manager.manage.search"
                        />
                    </div>
                </Form>

                <div className="form-group">
                    <RemarkComponent
                        title="Catalogue Remarks"
                        refId={values._id}
                        source="catalogue"
                    />
                </div>
            </div>
        </div>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        companyId: PropTypes.string,
        productId: PropTypes.string,
        // companyCommissionId: PropTypes.string,
        productCategory: PropTypes.string,
    }).isRequired,
};

let setSubmitting = () => { };
let resetForm = () => { };

const CatalogueForm = () => {
    const history = useHistory();

    // REDUX
    const dispatch = useDispatch();
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.CatalogueReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting, resetForm } = formikUtils);
        includeStamp(values);
        dispatch(catalogueUpsertAction(values));
        resetForm();
    }, [
        dispatch,
    ]);

    const onSearch = useCallback((values) => {
        const {
            companyId,
            productId,
            zoneId,
            catalogueName,
            pincode,
            catalogueType,
            meta,
        } = values;

        // search include all meta keys
        const metaSearchStrings = {};
        for (const key in meta) {
            if (Object.hasOwnProperty.call(meta, key)) {
                metaSearchStrings[`meta.${key}`] = meta[key];
            }
        }

        history.push(RoutingUtil.catalogueSearch({
            companyId,
            productId,
            zoneId,
            catalogueName,
            pincode,
            catalogueType,
            ...metaSearchStrings,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(catalogueResetAction());
    }, [
        dispatch,
    ]);

    return (
        <div>
            <Formik
                onSubmit={onSubmit}
                onClear={onClear}
                enableReinitialize
                initialValues={currentRecord}
                validationSchema={CatalogueYupSchema}
                onSearch={onSearch}
            >
                {(formikProps) => (
                    <Render
                        onClear={onClear}
                        onSearch={onSearch}
                        {...formikProps}
                    />
                )}
            </Formik>
        </div>
    );
};

export default CatalogueForm;
